import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Addwallet from '@/views/create/addWallet'
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
//push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: () => import('@/views/create/login.vue'),
            meta: {
                noLogin: true // 添加该字段，表示该路由无需登录
            }
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('@/views/create/register'),
            meta: {
                noLogin: true // 添加该字段，表示该路由无需登录
            }
        },
        {
            path: '/forgetPW',
            name: 'forgetPW',
            component: () => import('@/views/create/forgetPW'),
            meta: {
                noLogin: true // 添加该字段，表示该路由无需登录
            }
        },
        {
            path: '/addWallet',
            name: 'addWallet',
            component: Addwallet
        },
        {
            path: '/createWallet',
            name: 'createWallet',
            component: () => import('@/views/create/createWallet')
        },
        {
            path: '/importWallet',
            name: 'importWallet',
            component: () => import('@/views/create/importWallet')
        },
        {
            path: '/importWalletWord',
            name: 'importWalletWord',
            component: () => import('@/views/create/importWalletWord')
        },
        {
            path: '/GenerateMnemonic',
            name: 'GenerateMnemonic',
            component: () => import('@/views/create/GenerateMnemonic')
        },
        {
            path: '/VerifyMnemonic',
            name: 'VerifyMnemonic',
            component: () => import('@/views/create/VerifyMnemonic')
        },
        {
            path: '/setWalletPW',
            name: 'setWalletPW',
            component: () => import('@/views/create/setWalletPW')
        },
        {
            path: '/confirmWalletPW',
            name: 'confirmWalletPW',
            component: () => import('@/views/create/confirmWalletPW')
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/views/home'),
            redirect: {
                name: 'wallet'
            },
            children: [
                {
                    name: 'wallet',
                    path: 'wallet',
                    component: () => import('@/views/wallet/index')
                },
                {
                    name: 'vcl',
                    path: 'vcl',
                    component: () => import('@/views/vcl/index')
                },
                {
                    name: 'mine',
                    path: 'mine',
                    component: () => import('@/views/mine/index')
                }
            ]
        },
        {
            path: '/receive',
            name: 'receive',
            component: () => import('@/views/wallet/receive')
        },
        {
            path: '/dealDetails',
            name: 'dealDetails',
            component: () => import('@/views/wallet/dealDetails'),
            meta: {
                noLogin: true // 添加该字段，表示该路由无需登录
            }
        },
        {
            path: '/send',
            name: 'send',
            component: () => import('@/views/wallet/send')
        },
        {
            path: '/pay',
            name: 'pay',
            component: () => import('@/views/wallet/pay'),
            meta: {
              noLogin: true // 添加该字段，表示该路由无需登录
            }
        },
        {
            path: '/confirmDeal',
            name: 'confirmDeal',
            component: () => import('@/views/wallet/confirmDeal')
        },
        {
            path: '/payPW',
            name: 'payPW',
            component: () => import('@/views/wallet/payPW')
        },
        {
            path: '/valueline',
            name: 'valueline',
            component: () => import('@/views/vcl/valueline')
        },
        {
            path: '/mainNode',
            name: 'mainNode',
            component: () => import('@/views/vcl/mainNode')
        },
        {
            path: '/mainNodeError',
            name: 'mainNodeError',
            component: () => import('@/views/vcl/mainNodeError')
        },
        {
            path: '/mainNodeList',
            name: 'mainNodeList',
            component: () => import('@/views/vcl/mainNodeList')
        },

        {
            path: '/mainNodeSet',
            name: 'mainNodeSet',
            component: () => import('@/views/vcl/mainNodeSet')
        },
        {
            path: '/setting',
            name: 'setting',
            component: () => import('@/views/mine/setting')
        },
        {
            path: '/AboutUs',
            name: 'AboutUs',
            component: () => import('@/views/mine/AboutUs')
        },
        {
            path: '/funIntroduce',
            name: 'funIntroduce',
            component: () => import('@/views/mine/funIntroduce')
        },
        {
            path: '/showMnemonic',
            name: 'showMnemonic',
            component: () => import('@/views/mine/showMnemonic')
        },
        {
          path: '/showPrivatekey',
          name: 'showPrivatekey',
          component: () => import('@/views/mine/showPrivatekey')
      },
        {
            path: '/PrivacyPolicy',
            name: 'PrivacyPolicy',
            component: () => import('@/views/mine/PrivacyPolicy'),
            meta: {
                noLogin: true // 添加该字段，表示该路由无需登录
            }
        },
        {
            path: '/help',
            name: 'help',
            component: () => import('@/views/mine/help'),
            meta: {
                noLogin: true // 添加该字段，表示该路由无需登录
            }
        },
        {
            path: '/receiveSet',
            name: 'receiveSet',
            component: () => import('@/views/mine/receiveSet')
        },
        {
            path: '/nameAuthenticationSet',
            name: 'nameAuthenticationSet',
            component: () => import('@/views/mine/nameAuthenticationSet')
        },
        {
            path: '/nameAuthentication',
            name: 'nameAuthentication',
            component: () => import('@/views/mine/nameAuthentication')
        },
        {
            path: '/paymentAccount',
            name: 'paymentAccount',
            component: () => import('@/views/mine/paymentAccount')
        },
        {
            path: '/accountDetails',
            name: 'accountDetails',
            component: () => import('@/views/mine/accountDetails')
        },
        {
            path: '/addPaymentAccount',
            name: 'addPaymentAccount',
            component: () => import('@/views/mine/addPaymentAccount')
        },
        {
            path: '/BindBank',
            name: 'BindBank',
            component: () => import('@/views/mine/BindBank')
        },
        {
            path: '/bindAlipay',
            name: 'bindAlipay',
            component: () => import('@/views/mine/bindAlipay')
        },
        {
            path: '/bindWechat',
            name: 'bindWechat',
            component: () => import('@/views/mine/bindWechat')
        },
        {
            path: '/changeAccountPW',
            name: 'changeAccountPW',
            component: () => import('@/views/mine/changeAccountPW')
        },
        {
            path: '/changeWalletPW',
            name: 'changeWalletPW',
            component: () => import('@/views/mine/changeWalletPW')
        },
        {
            path: '/newWalletPW',
            name: 'newWalletPW',
            component: () => import('@/views/mine/newWalletPW')
        },
        {
            path: '/confirmPW',
            name: 'confirmPW',
            component: () => import('@/views/mine/confirmPW')
        },
        {
            path: '/cash',
            name: 'cash',
            component: () => import('@/views/mine/cash')
        },
        {
          path: '/cashRed',
          name: 'cashRed',
          component: () => import('@/views/mine/cashRed')
        },
        {
          path: '/chargeBalance',
          name: 'chargeBalance',
          component: () => import('@/views/mine/cashBalance')
        },
        {
          path: '/chargeGoods',
          name: 'chargeGoods',
          component: () => import('@/views/mine/cashGoods')
        },
        {
          path: '/cashNbtc',
          name: 'cashNbtc',
          component: () => import('@/views/mine/cashNbtc')
        },
        {
            path: '/cashRecords',
            name: 'cashRecords',
            component: () => import('@/views/mine/cashRecords')
        },
        {
          path: '/exRecords',
          name: 'exRecords',
          component: () => import('@/views/mine/exRecords')
        },
        {
            path: '/choicePaymentMethod',
            name: 'choicePaymentMethod',
            component: () => import('@/views/mine/ChoicePaymentMethod')
        },
        // {
        //     path: '/cashWalletPW',
        //     name: 'cashWalletPW',
        //     component: () => import('@/views/mine/cashWalletPW')
        // },
        {
            path: '/performanceRecord',
            name: 'performanceRecord',
            component: () => import('@/views/mine/performanceRecord')
        },
        {
          path: '/PensionFund',
          name: 'PensionFund',
          component: () => import('@/views/mine/PensionFund')
        },
        {
            path: '/IntegralRecord',
            name: 'IntegralRecord',
            component: () => import('@/views/mine/IntegralRecord')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('@/views/mine/contact')
        },
        {
            path: '/dividend',
            name: 'dividend',
            component: () => import('@/views/mine/dividend')
        },
        {
            path: '/shareAddress',
            name: 'shareAddress',
            component: () => import('@/views/wallet/shareAddress')
        },
        {
          path: '/checkBegin',
          name: 'checkBegin',
          component: () => import('@/views/vcl/checkBegin')
        },
        {
          path: '/checkQu',
          name: 'checkQu',
          component: () => import('@/views/vcl/checkQu')
        },
        {
          path: '/checkPassed',
          name: 'checkPassed',
          component: () => import('@/views/vcl/checkPassed')
        }
    ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
    if (from.path == '/home' && to.path == '/confirmWalletPW') {
        return
    }
    if (!store.state.user.hasLogin && to.path == '/home/wallet') {
        return
    }
    if (store.state.app.isinapp && to.path == '/') {
        return
    }
    if (!store.state.app.loadOver && (to.path == '/home/wallet' || to.path == '/')) {
        return
    }
    if (!to.meta.noLogin) {
        // 判断是否需要登录
        if (!store.state.user.hasLogin) {
            next('/')
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js